import usePrefix from '@/hooks/usePrefix';
import React, { useState } from 'react';
import ReceiptRecord from '../components/ReceiptRecord';
import UploadReceipt from '../components/UploadReceipt';

export interface SearchParams {
  phone?: string;
  user_code?: string;
  time_range?: string[];
}

const Upload = () => {
  const { prefix, classname } = usePrefix('bicester-receipt-upload');
  const [searchParams, setSearchParams] = useState<SearchParams>(null);

  return (
    <div className={classname}>
      <UploadReceipt setSearchParams={setSearchParams} />
      <ReceiptRecord searchParams={searchParams} />
    </div>
  );
};

export default Upload;
